// @flow
import React, { Component } from 'react';
//Styles
import './AddAfterExistsButton.css';

type Props = {
  currentQuantity: number,
  unitForQuantity: 'g' | 'un',
  loading: boolean,
  disableDecreaseQuantity?: boolean,
  disableIncrementQuantity?: boolean,
  largeSize?: Boolean,
  decreaseQuantity: () => void,
  increaseQuantity: () => void,
};

class AddAfterExistsButton extends Component {
  props: Props;
  render() {
    return (
      <div className={`add-after-exists-button-main ${this.props.largeSize ? 'add-after-exists-button-main-large' : ''}`}>
        <button
          onClick={this.props.decreaseQuantity}
          disabled={this.props.disableDecreaseQuantity}
        >
          <i className="fa fa-minus" aria-hidden="true"></i>
        </button>
        <div className={`add-after-exists-button-content${this.props.largeSize ? '-large' : ''}`}>
          <p className={`add-after-exists-button-content-value${this.props.largeSize ? '-large' : ''}`}>
            { this.props.unitForQuantity === 'g' ? (this.props.currentQuantity / 1000).toLocaleString('pt-br', {
              currency: 'BRL',
            }) : this.props.currentQuantity} {this.props.unitForQuantity === 'g' ? 'Kg' : this.props.unitForQuantity}

          </p>  
        </div>
        <button
          onClick={this.props.increaseQuantity}
          disabled={this.props.disableIncrementQuantity}
        >
          <i className="fa fa-plus" aria-hidden="true"></i>
        </button>
      </div>
    );
  }
}

AddAfterExistsButton.defaultProps = {
  disableDecreaseQuantity: false,
  disableIncrementQuantity: false,
};

export default AddAfterExistsButton;
